import ArtworkPlaceholder from '@/creator/components/ArtworkPlaceholder';

/**
 * Campaign cover art with an optional progress overlay. Renders the API artwork
 * when present, otherwise a neutral placeholder. Presentational only.
 */

const PROGRESS_MAX_PERCENT = 100;

type Accent = 'sky';

type Size = 'card' | 'featured' | 'detail';

type Props = {
    src?: string | null;
    alt?: string;
    accent?: Accent;
    size?: Size;
    progress?: number;
};

const CampaignArtwork = ({ src = null, alt = 'Campaign artwork', accent = 'sky', size = 'card', progress }: Props) => {
    const clampedProgress =
        typeof progress === 'number' && Number.isFinite(progress)
            ? Math.min(PROGRESS_MAX_PERCENT, Math.max(0, progress))
            : undefined;

    return (
        <div className={`campaign-art campaign-art--${accent} campaign-art--${size}`}>
            {src ? <img src={src} alt={alt} /> : <ArtworkPlaceholder />}
            {clampedProgress !== undefined ? (
                <span className="campaign-art__progress">
                    <b style={{ width: `${clampedProgress}%` }} />
                </span>
            ) : null}
        </div>
    );
};

export default CampaignArtwork;
